import client from '../client'

export async function buyNowListing({ buyNowListingId, acceptedPrices }) {
  return client(`${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/BuyNowListings/BuyNowListing`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ buyNowListingId, acceptedPrices }),
  })
}
